import { Component } from '@angular/core';

@Component({
  selector: 'app-detail-aha-gold-left-panel',
  templateUrl: './detail-aha-gold-left-panel.component.html',
  styleUrls: ['./detail-aha-gold-left-panel.component.scss'],
})
export class DetailAhaGoldLeftPanelComponent {}
